import { render, staticRenderFns } from "./ScreenLaudoSeriada.vue?vue&type=template&id=0592e34c&lang=true&"
import script from "./ScreenLaudoSeriada.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudoSeriada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports